import { isOuisenseEmail } from '@core/utils/ouisense-user.util'

import { type User, useAuth } from '@/hooks/use-auth'

// Règle « utilisateur OuiSense », utilisée par le hook (composants React) et directement dans les
// gardes de route (beforeLoad, hors React). La liste des domaines est partagée avec le backend
// (@core/utils/ouisense-user.util), que ouisenseOnlyMiddleware applique côté API : les deux doivent
// répondre la même chose, sinon une page s'affiche pour un utilisateur à qui l'API répondra 403.
export function isOuisenseUser(user: User | null | undefined): boolean {
  return isOuisenseEmail(user?.email)
}

// Variante hook réactive : se recalcule si l'utilisateur change. Garde les fonctionnalités internes
// (section admin, etc.). Hors React, préférer isOuisenseUser(useAuth.getState().user).
export function useIsOuisenseUser(): boolean {
  return useAuth((state) => isOuisenseUser(state.user))
}
